import React, { useContext, useState } from "react";
import Footer from "../../components/layout/Footer/Footer";
import Navbar from "../../components/layout/Navbar/Navbar";
import "./Blog.css";
import { Search, Calendar, User, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../context/ThemeContext";
import { blogCategories, blogPosts } from "./data/posts";

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const { theme } = useContext(ThemeContext);

  const filteredPosts = blogPosts.filter((post) => {
    const matchesCategory =
      selectedCategory === "all" || post.category === selectedCategory;
    const matchesSearch =
      post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const featuredPosts = filteredPosts.filter((post) => post.featured);
  const regularPosts = filteredPosts.filter((post) => !post.featured);

  return (
    <div className={`blog-page ${theme}`}>
      <Navbar />

      {/* Hero Section */}
      <section className={`blog-hero ${theme}`}>
        <div className="blog-hero-background">
          <div className="gradient-blob blob-1"></div>
          <div className="gradient-blob blob-2"></div>
        </div>

        <div className="blog-hero-content">
          <h1 className="blog-hero-title">Squaay Blog</h1>
          <p className="blog-hero-subtitle">
            Insights, tips, and stories from the Squaay community
          </p>
        </div>
      </section>

      {/* Search & Filter Section */}
      <section className={`blog-controls ${theme}`}>
        <div className="blog-container">
          <div className={`search-bar ${theme}`}>
            <Search size={20} />
            <input
              type="text"
              placeholder="Search articles..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className={`category-filter ${theme}`}>
            <label>Filter by Category:</label>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className={`category-select ${theme}`}
            >
              {blogCategories.map((cat) => (
                <option key={cat} value={cat}>
                  {cat === "all"
                    ? "All Categories"
                    : cat.charAt(0).toUpperCase() + cat.slice(1)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </section>

      {/* Featured Posts Section */}
      {featuredPosts.length > 0 && (
        <section className={`blog-feature ${theme}`}>
          <div className="blog-container">
            <h2 className={`section-title ${theme}`}>Featured Stories</h2>
            <div className="featured-grid">
              {featuredPosts.map((post) => (
                <article
                  key={post.id}
                  className={`featured-card ${theme}`}
                  onClick={() => navigate(`/blog/${post.id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="featured-image-wrapper">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="featured-image"
                    />
                    <div className="featured-overlay"></div>
                  </div>

                  <div className="featured-content">
                    <div className="post-meta">
                      <span className="category-badge">{post.category}</span>
                      <span className={`read-time ${theme}`}>{post.readTime}</span>
                    </div>

                    <h3 className={`post-title ${theme}`}>{post.title}</h3>
                    <p className={`post-excerpt ${theme}`}>{post.excerpt}</p>

                    <div className={`post-footer ${theme}`}>
                      {/* <div className="author-info">
                        <User size={16} />
                        <span>{post.author}</span>
                      </div> */}
                      <div className="post-date">
                        <Calendar size={16} />
                        <span>{post.date}</span>
                      </div>
                    </div>

                    <a href="#read" className="read-more">
                      Read More <ArrowRight size={18} />
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Latest Posts Section */}
      {regularPosts.length > 0 && (
        <section className="blog-latest">
          <div className="blog-container">
            <h2 className="section-title">Latest Articles</h2>
            <div className="posts-grid">
              {regularPosts.map((post) => (
                <article
                  key={post.id}
                  className="post-card"
                  onClick={() => navigate(`/blog/${post.id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="post-image-wrapper">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="post-image"
                    />
                    <div className="post-overlay"></div>
                  </div>

                  <div className="post-content">
                    <div className="post-header">
                      <span className="post-category">{post.category}</span>
                      <span className="post-time">{post.readTime}</span>
                    </div>

                    <h3 className="post-heading">{post.title}</h3>
                    <p className="post-description">{post.excerpt}</p>

                    <div className="post-info">
                      <div className="author">
                        <User size={14} />
                        <span>{post.author}</span>
                      </div>
                      <div className="date">
                        <Calendar size={14} />
                        <span>{post.date}</span>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* No Results */}
      {filteredPosts.length === 0 && (
        <section className="blog-no-results">
          <div className="blog-container">
            <div className="no-results-content">
              <h3>No articles found</h3>
              <p>Try adjusting your search or filter criteria</p>
            </div>
          </div>
        </section>
      )}

      {/* Newsletter Section */}
      {/* <section className="blog-newsletter">
        <div className="blog-container">
          <div className="newsletter-content">
            <h2>Stay Updated</h2>
            <p>Get the latest insights delivered to your inbox every week</p>

            <form
              className="newsletter-form"
              onSubmit={(e) => e.preventDefault()}
            >
              <input type="email" placeholder="your@email.com" required />
              <button type="submit">Subscribe</button>
            </form>
          </div>
        </div>
      </section> */}

      <Footer />
    </div>
  );
};

export default Blog;
